// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FeParamsHelperTs from "../../../../../component-library/src/ts-utils/analytics/helpers/FeParamsHelper.ts";

function moveSelectParamsToStore(prim0, prim1, prim2) {
  return FeParamsHelperTs.moveSelectParamsToStore(prim0, prim1, prim2);
}

function removeSelectParamsFromUrl(prim0, prim1) {
  return FeParamsHelperTs.removeSelectParamsFromUrl(prim0, prim1);
}

function getParsedDataFromStore(prim) {
  return FeParamsHelperTs.getParsedDataFromStore(prim);
}

function saveToStoreAndRedirect(prim0, prim1) {
  FeParamsHelperTs.saveToStoreAndRedirect(prim0, prim1);
}

function getUpdatedParamsFromStore(prim0, prim1, prim2) {
  return FeParamsHelperTs.getUpdatedParamsFromStore(prim0, prim1, prim2);
}

export {
  moveSelectParamsToStore ,
  removeSelectParamsFromUrl ,
  getParsedDataFromStore ,
  saveToStoreAndRedirect ,
  getUpdatedParamsFromStore ,
}
/* ../../../../../component-library/src/ts-utils/analytics/helpers/FeParamsHelper.ts Not a pure module */
